"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TableRow = exports.TableItem = exports.TableHeader = exports.TableBody = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Loading = _interopRequireDefault(require("../Loading"));
var _Table = require("./Table.style");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * 表格組件
 */

const Table = _ref => {
  let {
    className,
    margin,
    variant = "default",
    children,
    isSticky
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Table.UiTable, {
    className: className,
    issticky: isSticky,
    mb: margin,
    variant: variant
  }, children);
};
Table.propTypes = {
  className: _propTypes.default.string,
  variant: _propTypes.default.oneOf(["default", "light"]),
  margin: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  children: _propTypes.default.any,
  isSticky: _propTypes.default.bool
};
var _default = exports.default = Table;
const TableHeader = _ref2 => {
  let {
    className,
    children
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_Table.UiTableHeader, {
    className: className
  }, children);
};
exports.TableHeader = TableHeader;
TableHeader.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.any
};
const TableBody = _ref3 => {
  let {
    className,
    children,
    isLoading
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(_Table.UiTableBody, {
    className: className
  }, isLoading ? /*#__PURE__*/_react.default.createElement(_Loading.default, null) : children);
};
exports.TableBody = TableBody;
TableBody.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.any,
  isLoading: _propTypes.default.bool
};
const TableRow = _ref4 => {
  let {
    className,
    children,
    isSticky
  } = _ref4;
  return /*#__PURE__*/_react.default.createElement(_Table.UiTableRow, {
    className: className,
    issticky: isSticky
  }, children);
};
exports.TableRow = TableRow;
TableRow.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.any,
  isSticky: _propTypes.default.bool
};
const TableItem = _ref5 => {
  let {
    className,
    flex,
    children,
    isSticky
  } = _ref5;
  return /*#__PURE__*/_react.default.createElement(_Table.UiTableItem, {
    className: className,
    issticky: isSticky,
    flex: flex
  }, children);
};
exports.TableItem = TableItem;
TableItem.propTypes = {
  className: _propTypes.default.string,
  flex: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  children: _propTypes.default.any,
  isSticky: _propTypes.default.bool
};